export const environment = {

  /** Is production build flag */
  IS_PRODUCTION: process.env.REACT_APP_PROD === "1",

  /** Backend API base url */
  API_BASE_URL: `${process.env.REACT_APP_API_BASE_URL}/etsy/v1` as string,
  /** Shopify API key */
  SHOPIFY_API_KEY: process.env.REACT_APP_SHOPIFY_API_KEY as string,

  REACT_APP_SECRET_KEY: process.env.REACT_APP_SECRET_KEY as string,

  /** Optional static APP_BEARER_TOKEN token (if needed) */
  APP_BEARER_TOKEN: process.env.REACT_APP_BEARER ?? "",

  /** App server environment (local/dev/production) */
  SERVER_ENV: process.env.REACT_APP_SERVER_ENV ?? "local",

  /** App name */
  SHOPIFY_APP_NAME: process.env.REACT_APP_SHOPIFY_APP_NAME ?? "EcomZenith",

  /** Hotjar site ID */
  HOTJAR_SITE_ID: process.env.REACT_APP_HOTJAR_SITE_ID ?? "",
};
